import { create } from "../../../../../common/utils/zustand_state_manager";

/**
 * useObrasInformacoesGeraisFilter
 */

type State = {
  data: Date | null;
  informacoes: string | null;
};

export const useObrasInformacoesGeraisFilter = create<State>(() => ({
  data: null,
  informacoes: null,
}));